import { useState } from "react";
import { NavLink } from "react-router";
import {
  FooterColItemType,
  FooterCompmayInfoItemType,
} from "../../../utility/types/generaTypes";
import {
  COMPANY,
  FOOTER_COMPANY_INFO,
  SERVICES_FOOTER,
  SOCIAL_MEDIA,
  TECHNOLOGIES,
} from "../../../utility/utilityData";
import "./Footer.css";

const Footer = () => {
  const [hoveredSocialIconIndex, setHoveredSocialIconIndex] = useState<
    number | null
  >(null);
  return (
    <footer>
      <div className="footer_container">
        <div className="footer_leftcontainer">
          <h1 className="logo">
            <NavLink
              to="/"
              aria-label="JD SoftTech Home"
              className=" gradient_text"
            >
              JD SoftTech
            </NavLink>
          </h1>
          <p className="footer_leftcontainer_description">
            We're passionate about creating exceptional digital experiences that
            drive business growth and user engagement.
          </p>
          <div className="companyInfomations_container">
            {FOOTER_COMPANY_INFO.map((companyInfo, index) => (
              <CompanyInfo
                key={"CompanyInfo" + index}
                companyInfo={companyInfo}
              />
            ))}
          </div>
          <div className="socialmediaIcon_container">
            {SOCIAL_MEDIA.map((item, index) => (
              <a
                href={item.to}
                key={"SOCIAL_MEDIA" + index}
                onMouseEnter={() => setHoveredSocialIconIndex(index)}
                onMouseLeave={() => setHoveredSocialIconIndex(null)}
              >
                <img
                  src={
                    hoveredSocialIconIndex === index
                      ? item.hoverIcon
                      : item.icon
                  }
                  alt={item?.title + "_icon"}
                />
              </a>
            ))}
          </div>
        </div>
        <div className="footer_right_container">
          <Coloum colData={TECHNOLOGIES} />
          <Coloum colData={SERVICES_FOOTER} />
          <Coloum colData={COMPANY} />
        </div>
      </div>
      <div className="copy_rights">
        <div className="copy_rights_subContainer">
          <p className="copy_rights_text">
            Copyright © 2024 JD SoftTech. All rights reserved.
          </p>
          <ul className="copy_left_container">
            <li>
              <a href="">Privacy Policy</a>
            </li>
            <li>
              <a href="">Term of Services</a>
            </li>
            <li>
              <a href="">Cookies Policy</a>
            </li>
          </ul>
        </div>
      </div>
    </footer>
  );
};

type CompanyInfoProps = {
  companyInfo: FooterCompmayInfoItemType;
};

const CompanyInfo = ({ companyInfo }: CompanyInfoProps) => {
  return (
    <div className="companyInfo_container">
      <img src={companyInfo?.icon} alt={companyInfo?.title} />
      <p>{companyInfo?.label}</p>
    </div>
  );
};

type ColoumProps = {
  colData: FooterColItemType;
};

const Coloum = ({ colData }: ColoumProps) => {
  return (
    <div className="coloum">
      <h4>{colData?.title}</h4>
      <ul>
        {colData.data.map((item, index) => (
          <li key={"colData" + index}>
            <NavLink
              to={item?.to}
              title={item?.label}
              className={"navLink_footer"}
            >
              {item?.label}
            </NavLink>
          </li>
        ))}
      </ul>
    </div>
  );
};

export default Footer;
